import React from 'react';
import { Typography } from '@pinwheel/origami';
var MessageDetail = function (_a) {
    var message = _a.message, detail = _a.detail;
    return (React.createElement("div", { className: "MessageDetail", style: {
            height: 'fit-content',
            padding: '0px 24px',
        } },
        message && (React.createElement(Typography, { sx: { margin: '24px 0 8px 0' }, color: "default", variant: "body", align: "center" }, message)),
        detail && (React.createElement(Typography, { sx: { margin: '8px 0 24px 0' }, color: "light", variant: "caption", align: "center" }, detail))));
};
export default MessageDetail;
